import * as messageService from "../../services/message.service";
import * as lookupValuesService from "../../services/lookupValues.service";


const state = {
    lookupValuesAll:{},
};

const getters = {
    getLookupValuesAll:state => (state.lookupValuesAll),
};

const actions = {
    async fetchLookupValuesAll({ commit } ){
        try {
            
            const response = await lookupValuesService.all();
            commit('setLookupValuesAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            console.log('fetchLookupValuesAll - something wrong')
            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setLookupValuesAll:(state, res) => (
        state.lookupValuesAll =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}